import { createRouter, createWebHistory } from "vue-router";
export const loginRoutes = [];

const router = createRouter({
  history: createWebHistory(),
  // 配置路由切换时的滚动行为
  scrollBehavior(to, from, savedPosition) {
    // 对于自定义滚动容器，scrollBehavior可能无效，我们在afterEach中处理
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0, left: 0, behavior: 'smooth' };
  },
  routes: [
    {
      path: `/nav`,
      name: "main",
      component: () => import("@/page/main/main.vue"),
      children: [
        {
          // Overview
          path: `/`,
          name: "overview",
          component: () => import("@/page/home/overview.vue"),
          meta: { title: "overview" },
        },
        {
          // Api keys
          path: `/apiKeys`,
          name: "apiKeys",
          component: () => import("@/page/apiKey/apiKeys.vue"),
          meta: { title: "apiKeys" },
        },
        {
          // pricing
          path: `/pricing`,
          name: "pricing",
          component: () => import("@/page/price/pricing.vue"),
          meta: {
            title: "pricing",
          },
        },
        {
          // documentation
          path: `/documentation`,
          name: "documentation",
          component: () => import("@/page/home/overview.vue"),
          meta: {
            title: "documentation",
          },
        },
        {
          // billing
          path: `/billing`,
          name: "billing",
          component: () => import("@/page/billing/billing.vue"),
          meta: {
            title: "billing",
          },
        },
        {
          // terms
          path: `/terms`,
          name: "terms",
          component: () => import("@/page/home/overview.vue"),
          meta: {
            title: "terms",
          },
        },
        {
          path: `/payment-cn-result`,
          name: "pay-result",
          component: () => import("@/page/pay/result.vue"),
          meta: {
            title: "result",
          },
        },
      ],
    },
    {
      path: `/recoveraccount`,
      name: "recover",
      component: () => import("@/page/recover/recover.vue"),
    },
    {
      path: "/:pathMatch(.*)*", // 匹配所有未定义的路径
      name: "NotFound",
      component: () => import("@/page/notfound.vue"),
    },
  ],
});

// 在应用的状态中跟踪导航历史
export let navigationHistory = [];

// 监听路由变化
router.beforeEach((to, from, next) => {
  to.meta.from = from.fullPath;
  // 更新导航历史
  // 加入路由守卫，如果是mureka直接跳转到新版本的详情页
  next();
});

// 路由切换后重置滚动位置，特别处理自定义滚动容器
router.afterEach((to, from) => {
  // 只在不同路由间切换时重置滚动位置
  if (to.name !== from.name) {
    // 立即重置一次
    resetAllScrollPositions();
    
    // 延迟再重置一次确保DOM完全渲染后也能正确重置
    setTimeout(() => {
      resetAllScrollPositions();
    }, 100);
  }
});

// 重置所有滚动位置的通用函数
function resetAllScrollPositions() {
  try {
    // 检测是否为移动端
    const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    // 1. 重置window级别的滚动
    if (window.scrollY > 0 || window.pageYOffset > 0) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
    
    // 2. 重置主页面容器的滚动（最重要的）
    const mainPage = document.querySelector('.main-page');
    if (mainPage && mainPage.scrollTop > 0) {
      mainPage.scrollTop = 0;
    }
    
    // 3. 重置document.body的滚动
    if (document.body.scrollTop > 0) {
      document.body.scrollTop = 0;
    }
    
    // 4. 重置document.documentElement的滚动
    if (document.documentElement.scrollTop > 0) {
      document.documentElement.scrollTop = 0;
    }
    
    // 5. 移动端特殊处理
    if (isMobile) {
      // 强制重置视口
      if (window.scrollTo) {
        window.scrollTo(0, 0);
      }
      
      // 重置可能的iOS Safari地址栏滚动问题
      if (window.pageYOffset !== undefined) {
        window.pageYOffset = 0;
      }
      
      // 尝试触发重新布局
      document.body.style.minHeight = '100vh';
      setTimeout(() => {
        document.body.style.minHeight = '';
      }, 1);
    }
    
    // 6. 查找并重置其他滚动容器
    const scrollContainers = document.querySelectorAll('[style*="overflow"]');
    scrollContainers.forEach(container => {
      if (container.scrollTop > 0) {
        container.scrollTop = 0;
      }
    });
    
    // 7. 重置可能的CSS类滚动容器
    const cssScrollContainers = document.querySelectorAll('.overflow-auto, .overflow-scroll, .overflow-y-auto, .overflow-y-scroll');
    cssScrollContainers.forEach(container => {
      if (container.scrollTop > 0) {
        container.scrollTop = 0;
      }
    });
    
  } catch (error) {
    console.warn('重置滚动位置时出错:', error);
  }
}


export default router;
